import { usePostHog } from 'posthog-js/react';

/**
 * Returns whether a PostHog feature flag is enabled for the current user.
 *
 * Returns false when PostHog isn't initialised (e.g., local dev — see
 * frontend/CLAUDE.md §"Feature Flags"). Consumers should treat false
 * as the off-flag path and render the legacy fallback if any.
 */
export function useFeatureFlag(flag: string): boolean {
  const posthog = usePostHog();
  return posthog?.isFeatureEnabled(flag) ?? false;
}
